import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";

interface ComingSoonBadgeProps {
  className?: string;
  label?: string;
}

/**
 * Muted "Coming soon" pill for surfaces that are visible in the UI but
 * not yet wired to the backend.
 */
export function ComingSoonBadge({ className, label = "Coming soon" }: ComingSoonBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-muted px-2 py-0.5 text-[10px] font-medium text-muted-foreground",
        className,
      )}
    >
      <Clock className="h-3 w-3" />
      {label}
    </span>
  );
}

export default ComingSoonBadge;
